import React from 'react';
import { Box, InputAdornment, MenuItem, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DelayedTextField from '../../DelayedTextField';
import { RoleFilterOption, SortOption, USER_SORT_OPTIONS } from './userDisplayUtils';

interface UsersToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  roleFilter: string;
  roleFilterOptions: RoleFilterOption[];
  onRoleFilterChange: (value: string) => void;
  sortValue: string;
  onSortChange: (value: string) => void;
}

/** Controls row: debounced search + role filter + sort selects. */
const UsersToolbar = ({
  search,
  onSearchChange,
  roleFilter,
  roleFilterOptions,
  onRoleFilterChange,
  sortValue,
  onSortChange,
}: UsersToolbarProps) => (
  <Box
    sx={{
      display: 'flex',
      gap: 1.5,
      flexWrap: 'wrap',
      mb: 2.25,
      mt: 3,
    }}
  >
    <DelayedTextField
      value={search}
      onChange={onSearchChange}
      size="small"
      label="Search users"
      placeholder="Search by name or email"
      sx={{ flex: '1 1 260px', minWidth: 0 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
    <TextField
      select
      size="small"
      label="Role"
      value={roleFilter}
      onChange={(event) => onRoleFilterChange(event.target.value)}
      sx={{ flex: 'none', minWidth: 170 }}
    >
      {roleFilterOptions.map((option: RoleFilterOption) => (
        <MenuItem key={option.value} value={option.value}>
          {option.value}
        </MenuItem>
      ))}
    </TextField>
    <TextField
      select
      size="small"
      label="Sort by"
      value={sortValue}
      onChange={(event) => onSortChange(event.target.value)}
      sx={{ flex: 'none', minWidth: 150 }}
    >
      {USER_SORT_OPTIONS.map((option: SortOption) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  </Box>
);

export default UsersToolbar;
